<template>
  <v-container>
    <div id="grid-historico">
      <template>
        <v-btn
          color="lime darken-2"
          dark
          class="mb-3"
          @click="volver(id, code)"
        >
          <v-icon right dark>arrow_back_ios</v-icon>Volver
        </v-btn>
      </template>
      <v-toolbar card color="white">
        <v-toolbar-title class="indigo--text"
          >Revisión de archivos enviados al reporte:
          {{ descripcionProducto }}</v-toolbar-title
        >
      </v-toolbar>
      <v-toolbar card color="white">
        <v-toolbar-title class="indigo--text"
          >Archivo inicial enviado por proveedor:
          {{ filename }}</v-toolbar-title
        >
      </v-toolbar>

      <v-layout justify-center>
        <v-flex xs12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <v-data-table
            v-if="!alerta"
            :headers="headers"
            :items="itemsProductos"
            :rows-per-page-items="rowsTable"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.filename }}</td>
              <td>{{ props.item.usuario }}</td>
              <td class="text-xs-left">{{ props.item.observaciones }}</td>
              <td class="text-xs-left">{{ props.item.estado }}</td>
              <td class="text-xs-left">{{ props.item.fechaCreacion }}</td>
              <td class="text-xs-left">
                <v-btn
                  v-if="
                    props.item.filename != null && props.item.filename != ''
                  "
                  depressed
                  outline
                  title="Descargar documento"
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  @click="downloadFile(props.item.id, props.item.filename)"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";

export default {
  name: "grid-aprobacion-reporte",

  components: {
    Loading,
    AlertEmpty,
  },
  props: {
    rowsTable: String,
    tipeView: String,
  },

  data() {
    return {
      filename: "",
      producto: "",
      loading: false,
      usuarioLoggedTipe: "",
      dialog: false,
      alerta: false,
      id: "",
      code: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      idContrato: "",
      headers: [
        {
          text: "Nombre de archivo",
          align: "left",
          sortable: false,
          value: "filename",
        },
        { text: "Usuario", sortable: false, value: "usuario" },
        { text: "Observaciones", sortable: false, value: "observaciones" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Fecha Creación", sortable: false, value: "fecha" },
        { text: "Descargar Archivo", sortable: false, value: "estado" },
      ],
      itemsProductos: [],
      proceso: "",
    };
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idReporte = this.$route.params.idReporte;
    this.id = this.$route.params.id;
    this.code = this.$route.params.code;
    this.filename = this.$route.params.filename;
    this.descripcionProducto = this.$route.params.descripcionProducto;
    this.loadData();
    // console.log("aprobacion:" + JSON.stringify(this.$route.params, null, 2));
  },

  mounted() {},
  computed: {},
  methods: {
    async loadHistoric() {
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        idProductosReporte: this.id,
      };
      return await axios
        .get("/productoReporte/relat/" + this.idReporte + "/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },
    async loadProduct() {
      return await axios
        .get("/productoReporte/relat/" + this.idReporte + "/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsProductos = await this.loadHistoric();
      if (this.itemsProductos.length > 0) {
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    reload() {
      setTimeout(() => {
        this.$parent.reloadDocumento();
      }, 1000);
    },
    addNewReport(id, code) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ProductosRegistraReporte",
          params: { id: id, code: code, tipeView: "crear" },
        });
      }, 1000);
    },
    downloadFile(id, filename) {
      this.body = {
        fileName: filename,
        idContrato: this.idContrato,
        id: id,
      };

      axios
        .post("productoReporte/downloadFile/", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    volver(id, code) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "GridHistoricoProdReporte",
          params: { id: id, codigo: code, tipeView: "consulta" },
        });
      }, 1000);
    },
  },
};
</script>
